import { StatusCodes } from 'http-status-codes'

export const FOUND = StatusCodes.MOVED_TEMPORARILY
export const errorMessages: Record<string, string> = {
  [FOUND]:
    'Web Wisdom AI Concierge already exists. Redirecting to dashboard...',
  default: 'Oops! Something went wrong. Please try again.',
}
